<template>
  <div class="promo-popup" v-if="isVisible">
    <div class="promo-content">
      <img class="logocloud" style="height:35px; margin-bottom:15px;" src="../assets/images/giftcloudb.png" alt="logo-icon">
      <h3 style="font-size:20px;">5€ FREE BALANCE<br/></h3>
      <p>Register to cloudblast and get 5€ cloud credit to deploy your VPS's </p>
      <a target="_blank" href="https://console.cloudblast.io/auth/login?ref=2" class="btn-style material-color btn-arrow"><span style="font-weight:500;font-size:18px;color:#fff;">Claim Free 5€<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.00002 0.710632C0.61002 1.10063 0.61002 1.73063 1.00002 2.12063L4.88002 6.00063L1.00002 9.88063C0.61002 10.2706 0.61002 10.9006 1.00002 11.2906C1.39002 11.6806 2.02002 11.6806 2.41002 11.2906L7.00002 6.70063C7.39002 6.31063 7.39002 5.68063 7.00002 5.29063L2.41002 0.700632C2.03002 0.320632 1.39002 0.320632 1.00002 0.710632Z" fill="white"/>
</svg></span></a>
    </div>
    <button class="close-btn" @click="closePopup">×</button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PromotionalPopup',
  data() {
    return {
      isVisible: true
    };
  },
  methods: {
    closePopup() {
      this.isVisible = false;
      // Store in localStorage to prevent showing again for 24 hours
      localStorage.setItem('promoPopupClosed', new Date().toISOString());
    },
    handleLearnMore() {
      // For testing: Clear localStorage and redirect
      localStorage.removeItem('promoPopupClosed');
      window.location.href = '/pricing';
    }
  },
  mounted() {
    // Check if popup was closed in the last 24 hours
    const lastClosed = localStorage.getItem('promoPopupClosed');
    if (lastClosed) {
      const lastClosedDate = new Date(lastClosed);
      const now = new Date();
      const hoursDiff = (now.getTime() - lastClosedDate.getTime()) / (1000 * 60 * 60);
      if (hoursDiff < 24) {
        this.isVisible = false;
      } else {
        // If more than 24 hours have passed, remove the item and show popup
        localStorage.removeItem('promoPopupClosed');
        this.isVisible = true;
      }
    }
  }
});
</script>

<style scoped>
.promo-popup {
  position: fixed;
  bottom: 20px;
  right: 20px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 40px;
  z-index: 1000;
  width: 300px;
  animation: slideIn 0.5s ease-out;
  background: rgba(17, 18, 24, 0.6980392157);
  border: 1px solid;
}

@keyframes slideIn {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.promo-content {
  text-align: center;
}

.promo-content h4 {
  margin: 0 0 10px;
  color: #fff;
  font-size: 1.2em;
}

.promo-content p {
  margin: 0 0 15px;
  color: #9C9EAB;
}

.promo-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

.promo-btn:hover {
  background: #0056b3;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:hover {
  background: #161820;
}
</style>
